import { useEffect, useMemo } from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { IMAGE_QUERY_PARAMS } from '../constants.js';
import { GET_MY_ORDER_HISTORY } from '../operations/queries/get-my-order-history.js';
import { toOverviewOrder } from '../mappers/view/orders/order-overview.js';

const useGetMyOrderHistory = ({ pageSize =0 , offset =0 , onCompleted , onError  } = {})=>{
    var ref;
    const intl = useIntl();
    const { isPrescriptionGlassesReorderEnabled  } = useFeatureToggles();
    const { data , error , loading , fetchMore  } = useQuery(GET_MY_ORDER_HISTORY, {
        variables: {
            offset,
            limit: pageSize
        },
        onCompleted,
        // `notifyOnNetworkStatusChange` makes sure that the loading state is updated when fetchMore is called
        notifyOnNetworkStatusChange: true
    });
    const { results: orders = [] , total =0  } = (data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.orders) || {};
    useEffect(()=>{
        if (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    }, [
        error,
        onError
    ]);
    return useMemo(()=>{
        return [
            {
                fetchMore
            },
            {
                data: {
                    total,
                    orders: orders.map((order)=>toOverviewOrder(order, intl, {
                            isPrescriptionGlassesReorderEnabled,
                            imageQueryParams: IMAGE_QUERY_PARAMS
                        })
                    ),
                    loading,
                    error
                }
            }, 
        ];
    }, [
        fetchMore,
        total,
        orders,
        loading,
        error,
        intl,
        isPrescriptionGlassesReorderEnabled
    ]);
};

export { useGetMyOrderHistory };
//# sourceMappingURL=use-get-my-order-history.js.map
